module.exports = __webpack_public_path__ + "img/avatar3.a73772a7.png";